<template>
  <div v-show="props.title" class="module-text-container">
    <div class="module-text-title">
      <div class="module-text-title-square"></div>
      <div class="module-text-title-text">{{ props.title }}</div>
      <div class="module-text-title-line">
        <div class="module-text-title-line-bold"></div>
        <div class="module-text-title-line-normal"></div>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  title: String
})

</script>
<script>
export default {
  name: 'ModuleTitleView'
}
</script>

<style lang="less">
.module-text-container {
  width: 100%;
  overflow: hidden;

  .module-text-title {
    display: flex;
    align-items: flex-end; /* 使所有子元素底部对齐 */

    .module-text-title-square {
      width: 9px;
      height: 28px;
      background-color: var(--main-color); /* 设置背景颜色 */
      border-radius: 2px;
    }

    .module-text-title-text {
      margin-left: 27px;
      font-size: 24px;
      font-weight: bold;
      color: var(--main-color);
      letter-spacing: 1px;
    }

    .module-text-title-line {
      flex-grow: 1; /* 使线条自适应父容器的宽度 */
      margin-left: 27px;
      margin-bottom: 4px;

      .module-text-title-line-bold {
        width: 100%;
        height: 6px;
        background-color: var(--main-color);
      }

      .module-text-title-line-normal {
        width: 100%;
        height: 1px;
        margin-top: 2px;
        background-color: var(--main-color);
      }
    }
  }
}
</style>